module.exports = __webpack_public_path__ + "media/images/icons/clover-35a635e61dfa39fd6c338d6eace81a30.svg";